import { render, staticRenderFns } from "./StoreSplitRule.vue?vue&type=template&id=3badcf29&scoped=true&"
import script from "./StoreSplitRule.vue?vue&type=script&lang=ts&"
export * from "./StoreSplitRule.vue?vue&type=script&lang=ts&"
import style0 from "./StoreSplitRule.vue?vue&type=style&index=0&id=3badcf29&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3badcf29",
  null
  
)

export default component.exports